interface DataWithErrorId {
    details: {
        customErrorId: string;
    };
}

const hasCustomErrorId = (data: unknown): data is DataWithErrorId => {
    const customErrorId = (data as DataWithErrorId)?.details?.customErrorId;
    return typeof customErrorId === 'string';
};

export const deserializeErrorCode = (data: unknown): string | undefined => {
    if (hasCustomErrorId(data)) {
        return data.details.customErrorId;
    }

    return undefined;
};
